module.exports = __webpack_public_path__ + "img/DE01536.f7b228a4.png";